<template>
  <div class="home" v-show="appReady && userIsLoggedIn">

    <div v-if="cardData && loaded" class="content">

      <h2 v-if="!changeCard" class="text-center f-m mb-5" style="font-size: 16px;">Riepilogo</h2>


      <div v-if="!changeCard" class="card__box md:w-1/2 m-center p-5 rounded">
        <p class="mb-5">Ecco la tua carta: </p>
        <img v-if="cardImage" class="card-img shadow-lg" :src="cardImage" />
        <div class="text-center mt-8" v-if="selectedCard">
          <p v-if="selectedCard.promo" class="promo-label mt-1 mb-2" @click="openInfoPromoModal">
            Promo <span class="icon icon-info-white"></span>
          </p>

          <p class="f-b mb-5">
            Costo della carta:

            <!-- Promo price block -->
            <span v-if="selectedCard.promo">
              <span class="card-old-price f-r">
                <span v-if="feePot && feePot.availableAmount > 0 && selectedCard.price > 0">
                  {{ selectedCard.price | currencyWithZeroValue }}
                </span>
                <span v-else>
                  {{ selectedCard.promo.oldPrice | currencyWithZeroValue }}
                </span>

              </span>
              <span class="card-promo-price f-b">
                <span v-if="selectedCard.price === 0">{{ selectedCard.price | currencyWithZeroValue }}</span>
                <span v-else>
                  <span v-if="feePot && feePot.availableAmount > 0"> Power
                    <span v-if="selectedCard.price - feePot.availableAmount <= 0">{{ 0 | currencyWithZeroValue }}</span>
                    <span v-else>{{ selectedCard.price - feePot.availableAmount | currencyWithZeroValue }}</span>
                  </span>
                  <span v-else>
                    {{ selectedCard.price | currencyWithZeroValue }}
                  </span>
                </span>
              </span>

            </span>

            <!-- Regular price block -->
            <span v-else>
              <span v-if="feePot && feePot.availableAmount > 0 && selectedCard.price > 0">
                <span class="card-old-price f-r">{{ selectedCard.price | currencyWithZeroValue }}</span>
                <span class="card-promo-price f-b">
                  Power
                  <span v-if="selectedCard.price - feePot.availableAmount <= 0">{{ 0 | currencyWithZeroValue }}</span>
                  <span v-else>{{ selectedCard.price - feePot.availableAmount | currencyWithZeroValue }}</span>
                </span>
              </span>
              <span v-else>{{ selectedCard.price | currencyWithZeroValue }}</span>
            </span>
          </p>

          <p class="">
            Tipo di carta: <b>{{ selectedCard.cardType === "PHYSICAL" ? 'Fisica' : 'Virtuale' }}</b>
          </p>
          <p  v-if="selectedCard && selectedCard.content && selectedCard.content.expirationDate" class="mt-2">
            Scadenza: <b>{{ selectedCard.content.expirationDate }}</b>
          </p>
        </div>
      </div>


      <p v-if="!selectedCardNotAvailable && cardData && cardData.length > 1" @click="changeCard = !changeCard" class="link text-center mt-5 mb-10 cursor-pointer" style="font-size: 12px;">
        {{ changeCard ? 'Indietro' : 'Cambia carta' }}</p>

      <div v-if="changeCard">
        <b v-if="selectedCardNotAvailable" style="margin-top: -5px; font-size: 14px;" class="flex text-grey text-center mt-5 mb-10">
          Attenzione!<br /> La carta precedentemente selezionata non è più disponibile. {{ cardData.length > 1 ? "Si prega di selezionarne un'altra." : "" }} 
        </b>
        <p class="text-grey text-center mt-5 mb-10">
           {{ cardData.length > 1 ? "Quale carta vuoi richiedere?" : "Ecco la tua carta:" }}
        </p>
        <SmoothCarousel :data="cardData" :onSelect="selectCardHandler" :startIndex="startIndex" />
        <div class="text-center mt-8" v-if="currentCard">
          <p v-if="currentCard.promo" class="promo-label mt-1 mb-2" @click="openInfoPromoModal">
            Promo <span class="icon icon-info-white"></span>
          </p>

          <p class="f-b mb-5">
            Costo della carta:

            <!-- Promo price block -->
            <span v-if="currentCard.promo">
              <span class="card-old-price f-r">
                <span v-if="feePot && feePot.availableAmount > 0 && currentCard.price > 0">
                  {{ currentCard.price | currencyWithZeroValue }}
                </span>
                <span v-else>
                  {{ currentCard.promo.oldPrice | currencyWithZeroValue }}
                </span>

              </span>
              <span class="card-promo-price f-b">
                <span v-if="currentCard.price === 0">{{ currentCard.price | currencyWithZeroValue }}</span>
                <span v-else>
                  <span v-if="feePot && feePot.availableAmount > 0"> Power
                    <span v-if="currentCard.price - feePot.availableAmount <= 0">{{ 0 | currencyWithZeroValue }}</span>
                    <span v-else>{{ currentCard.price - feePot.availableAmount | currencyWithZeroValue }}</span>
                  </span>
                  <span v-else>
                    {{ currentCard.price | currencyWithZeroValue }}
                  </span>
                </span>
              </span>

            </span>

            <!-- Regular price block -->
            <span v-else>
              <span v-if="feePot && feePot.availableAmount > 0 && currentCard.price > 0">
                <span class="card-old-price f-r">{{ currentCard.price | currencyWithZeroValue }}</span>
                <span class="card-promo-price f-b">
                  Power
                  <span v-if="currentCard.price - feePot.availableAmount <= 0">{{ 0 | currencyWithZeroValue }}</span>
                  <span v-else>{{ currentCard.price - feePot.availableAmount | currencyWithZeroValue }}</span>
                </span>
              </span>
              <span v-else>{{ currentCard.price | currencyWithZeroValue }}</span>
            </span>
          </p>
        </div>

      </div>



    </div>
    <div class="page-footer">
      <!-- POWER banner-->
      <div v-if="feePot === null && isMinor === false" class="mt-5 mb-5 px-5">
        <PowerBanner />
      </div>

      <button v-if="changeCard" class="btn" @click="chooseCard">
        OK
      </button>

      <button  v-if="!changeCard" class="btn" @click="next">
        Prosegui
      </button>

    </div>


    <Modal id="infoPromoModal" class="modal-centered" title="Promo carta fisica">
      <template v-slot:content>
        <div v-if="currentCard && currentCard.promo">
          <div class="info-modal-card shadow-md m-3">
            <img :src="currentCard.imageFront" />
          </div>
          <div class="flex flex-col items-center mb-5">
            <p class="mt-2">Costo della carta:</p>
            <div class="info-modal-price flex mt-3">
              <p class="promo-label mr-2">
                Promo
              </p>
              <p class="promo-modal-price f-b">{{ currentCard.price | currencyWithZeroValue }}</p>
            </div>
            <div class="info-modal-text-grey">
              anziché: <span class="card-old-price">{{ currentCard.promo.oldPrice | currencyWithZeroValue }}</span>
            </div>
          </div>
          <div class="card-promo-link" @click="openUrl(currentCard.promo.regulationLink)">
            Leggi il regolamento
          </div>
        </div>
      </template>
    </Modal>

    <Modal id="virtualCardModal" class="modal-centered" title="Richiesta Carta">
      <template v-slot:content>
        <div v-if="currentCard && currentCard.physicalCard">
          <p>Stai richiedendo una carta virtuale</p>
          <b>Costo: {{ currentCard.price | currencyWithZeroValue }}</b>
          <div class="w-full mb-10">
            <div class="tnb-checkbox">
              <div class="inline-flex">
                <input type="checkbox" id="requestPhysicalCard" v-model="requestPhysicalCard" />
                <label for="requestPhysicalCard" class="text-left">Richiedi anche una carta fisica<br />
                  <b>Costo
                    <span v-if="feePot" style="text-decoration: line-through; margin-right: 10px;">{{
                      currentCard.physicalCard.price | currencyWithZeroValue }}</span>
                    <span v-else>{{ currentCard.physicalCard.price | currencyWithZeroValue }}</span>

                    <span v-if="feePot" class="card-promo-price f-b">
                      Power
                      <span v-if="currentCard.physicalCard.price - feePot.availableAmount <= 0">{{ 0 |
                        currencyWithZeroValue }}</span>
                      <span v-else>{{ currentCard.physicalCard.price - feePot.availableAmount | currencyWithZeroValue
                        }}</span>
                    </span>
                  </b>
                </label>
              </div>
            </div>
          </div>


        </div>
      </template>

      <template v-slot:buttons>
        <!-- POWER banner-->
        <div v-if="feePot === null && isMinor === false" class="mb-5">
          <PowerBanner />
        </div>
        <button class="btn btn--outline" style="min-width: 150px"
          @click="() => $root.$emit('closeModal', 'virtualCardModal')" type="button">
          Annulla
        </button>
        <button class="btn" style="min-width: 150px" @click="confirmCard" type="button">
          Prosegui
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
//import UserService from "@/services/UserService";
import store from "@/store";
import ApiService from "@/services/ApiService";
import UtilityService from "@/services/UtilityService";
import RegistrationService from "@/services/RegistrationService";
import SmoothCarousel from "@/components/SmoothCarousel";
import PowerBanner from "@/components/PowerBanner";
import Modal from "@/components/Modal";
import CrmService from "@/services/CrmService";

export default {
  name: "Home",
  components: {
    SmoothCarousel,
    Modal,
    PowerBanner
  },
  computed: {
    userIsLoggedIn() {
      return store.state.loggedIn;
    },
    appReady() {
      return store.state.appReady;
    }
  },

  data() {
    return {
      loaded: false,
      selectedCard: {}, //card choosen in previous step
      currentCard: {},
      cardData: [],
      startIndex: 0,
      requestPhysicalCard: false,
      feePot: undefined,
      isMinor: undefined,
      cardImage: "",
      changeCard: false
    };
  },

  mounted() {
    this.check();
  },
  methods: {
    async check() {
      await this.getCards();
      this.feePot = await CrmService.getFeePot();
      this.loaded = true;
    },
    async setCardImage() {
      console.log("setCardImage", this.selectedCard);
      this.cardImage =
        this.selectedCard && this.selectedCard.content?.imagesUrl?.front
          ? this.selectedCard.content.imagesUrl.front
          : (await import("../../assets/images/carta-tinaba-orange.png")).default;
    },
    chooseCard() {
      this.changeCard = false;
      this.selectedCard = this.currentCard;
      this.selectedCard.content = {};
      this.selectedCard.content.imagesUrl = {};
      this.selectedCard.content.imagesUrl.front = this.selectedCard.imageFront;
      this.selectedCardNotAvailable = false;
      this.setCardImage();
    },
    enablePower() {
      this.$root.$emit("closeModal", "virtualCardModal");
      UtilityService.goToFeePot();
    },
    openInfoPromoModal() {
      this.$root.$emit("openModal", "infoPromoModal");
    },
    openLoginModal() {
      this.$root.$emit("openModal", "loginModal");
    },
    backToInitialView() {
      UtilityService.backToInitialView();
    },
    async getCards() {
      this.$root.$emit("openGlobalLoader");
      const prepaidCards = await ApiService.get("/usr/v2/prepaid-cards");

      let cards = prepaidCards.data;

      this.selectedCard = cards?.find(
        c => c.id === store.state.registrations.prepaidCardResource.id
      );
      console.log("selectedCard", this.selectedCard);
      if (this.selectedCard) {
        this.selectedCard.promo = this.selectedCard?.content?.promo;
      } else {
        this.selectedCardNotAvailable = true;
        this.changeCard = true;
      }
      
      this.currentCard = this.selectedCard;

      await this.setCardImage();

      //Remap for pairing virtual and physical cards
      cards.forEach(card => {
        if (card.relatedCardId) {
          cards.filter(c => c.id === card.relatedCardId)[0][
            "physicalCard"
          ] = card;
        }
      });

      this.cardData = cards
        .filter(c => !c.relatedCardId) //remove from list physical cards that already has a related virtual card in list
        .map(c => {
          return {
            id: c.id,
            name: c.name,
            price: c.price,
            image: c.content?.imagesUrl?.vertical,
            imageFront: c.content?.imagesUrl?.front,
            promo: c.content?.promo,
            profile: c.profile,
            physicalCard: c.physicalCard,
            cardType: c.cardType,
            expirationDate: c.content?.expirationDate,
            selectedCardNotAvailable: false
          };
        });

      this.$root.$emit("closeGlobalLoader");
    },
    openUrl(url) {
      UtilityService.openUrl(url);
    },
    selectCardHandler(cardId) {
      const selectedCard = this.cardData.filter(c => c.id === cardId)[0];
      console.log("selected", selectedCard);
      this.currentCard = selectedCard;
    },
    confirmCard() {
      this.$root.$emit("closeModal", "virtualCardModal");
      if (this.requestPhysicalCard) {
        this.submitCard(this.currentCard.physicalCard);
      } else {
        this.submitCard(this.currentCard);
      }
    },
    async upgradeCard() {
      let req = {
        upgradeFlow: true
      };

      try {
        await RegistrationService.startPrepaidCardRequest(req);
        await RegistrationService.getMyRegistrations();
        this.$root.$emit("submitStep");
      } catch (error) {
        console.log(error);
        UtilityService.showDefaultError(error);
      }
    },
    async submitCard(card) {
      let req = null;
      //TODO: put card id

      const oldCardId = store.state.registrations.prepaidCardResource.id;
      const newCardId = card.id;
      console.log("next", oldCardId, newCardId);
      if (oldCardId === newCardId) {
        this.$root.$emit("submitStep");
        return;
      }

      if (card?.id) {
        req = { prePaidCardId: card.id };
      }

      try {
        await RegistrationService.selectCard(req);
        await RegistrationService.getMyRegistrations();
        this.$root.$emit("submitStep");
      } catch (error) {
        console.log(error);
        UtilityService.showDefaultError(error);
      }
    },
    async next() {
      event.preventDefault();
 
      try {
        const hasPhysicalCard = !!this.selectedCard.physicalCard;
        if (hasPhysicalCard) {
          this.$root.$emit("openModal", "virtualCardModal");
        } else {
          this.submitCard(this.selectedCard);
        }
      } catch (error) {
        UtilityService.showDefaultError(error);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  @media (max-width: 768px) {
    .carousel img {
      max-width: 40%;
    }

    .landing-subtitle {
      font-size: 13px !important;
      text-align: center;
    }
  }

  h1 {
    font-size: 28px;
  }

  .landing-subtitle {
    font-size: 18px;
  }

  .card {
    .card__box {
      padding: 30px 25px;
      min-height: 240px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .box-list {
        list-style: disc;
        margin-left: 20px;

        li {
          padding-left: 15px;
          padding-bottom: 5px;
        }
      }

      .card__box__img-influencer {
        width: 50%;
        min-width: 190px;
        margin: 20px auto;
      }

      .btn {
        width: 300px;
        margin-top: 30px;
      }

      .pay-methods {
        display: flex;
        justify-content: space-around;

        div {
          width: 50px;
          height: 50px;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;

          &.applePay {
            background-image: url("../../assets/images/applePay_top.png");
          }

          &.samsungPay {
            background-image: url("../../assets/images/samsung_pay_badge.png");
          }

          &.garminPay {
            background-image: url("../../assets/images/garminPay_top.jpg");
          }

          &.googlePay {
            background-image: url("../../assets/images/googlePay_top.jpg");
          }

          &.fitbitPay {
            background-image: url("../../assets/images/fitbitPay_top.png");
          }

          &.swatchPay {
            background-image: url("../../assets/images/swatchPay.png");
          }

          //mobile sizes
          @media (max-width: 768px) {
            &.applePay {
              width: 56px;
            }

            &.garminPay {
              width: 82px;
            }

            &.googlePay {
              width: 64px;
            }

            &.fitbitPay {
              width: 93px;
            }

            &.swatchPay {
              width: 60px;
              margin-left: 10px;
            }
          }
        }
      }
    }

    h2 {
      font-size: 15px;
    }

    p {
      font-size: 14px;
      line-height: 20px;
    }
  }

  h3 {
    font-size: 18px;
    text-align: center;
    margin: 50px auto 20px;
  }

  .app-links {
    justify-content: center;

    img {
      width: 150px;
      margin-right: 20px;
    }
  }

  .carousel {
    align-self: center;

    img {
      width: 75%;
      margin: 0 auto;
    }

    p {
      margin: 0 auto;
      width: 60%;
      font-size: 18px;
    }
  }
}

.promo-label {
  background: #CC4B00;
  color: white;
  border-radius: 5px;
  font-size: 10px;
  text-align: center;
  display: flex;
  width: fit-content;
  margin: 0 auto 8px;
  align-items: center;
  justify-content: space-between;
  padding: 3px 5px;

  .icon-info-white {
    margin-top: -4px;
    margin-right: 3px;
    margin-left: 5px;
  }
}

.card-old-price {
  text-decoration: line-through;
  color: #9d9d9d;
  margin: 0 10px;
  font-size: 12px;
}

.card-promo-price {
  color: #CC4B00;
  font-size: 15px;
  display: block;
}

.card-promo-link {
  cursor: pointer;
  display: block;
  font-family: "Be Vietnam Pro Regular";
  color: #CC4B00;
  font-size: 11px;
  margin-top: 5px;
}

.tnb-checkbox {
  background: #CC4B0030;
  border-radius: 10px;
  margin-top: 30px !important;

  input {
    align-self: center;
  }

  label {
    padding: 10px;
    color: black !important;
  }

  .inline-flex {
    padding: 0 15px;
    width: 100%;
  }
}

.power-modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 180px;
    margin-top: 10px;
  }

  .power-box {
    line-height: 20px;
    border: 1px solid #eaeaea;
    border-radius: 5px;
    padding: 15px 20px;
    margin: 26px 10px 25px;
    text-align: left;

    ul {
      list-style-type: disc;
      margin-left: 20px;
      margin-bottom: 5px;
    }
  }

  .power-image {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-bottom: 20px;
    }
  }
}

.icon-info {
  width: 20px;
  height: 20px;
  margin-bottom: -5px;
  margin-left: 3px;
  display: inline-block;
}

.icon-info-white {
  width: 14px;
  height: 14px;
  margin-bottom: -5px;
  margin-left: 3px;
  display: inline-block;
}

.info-modal-card {
  border: 1px solid #f2f2f2;
  border-radius: 10px;
}

.promo-modal-price {
  font-size: 26px;
}

.info-modal-price {
  .promo-label {
    height: 20px;
    align-self: center;
    color: #CC4B00;
    background: white;
    border: 1px solid #CC4B00;
    margin-right: 10px;
  }
}

.info-modal-text-grey {
  color: #9d9d9d
}
</style>
<style lang="less"></style>
